const competitionRunningTimes = [
  {
    start: new Date("11 October 2023 9:00:00 GMT+0100"),
    end: new Date("27 October 2023 23:59:00 GMT+0100"),
  },
  {
    start: new Date("08 November 2023 9:00:00 GMT"),
    end: new Date("26 November 2023 23:59:00 GMT"),
  },
  {
    start: new Date("07 December 2023 12:00:00 GMT"),
    end: new Date("31 December 2023 23:59:00 GMT"),
  },
];

export const isCompetitionOpen = () => {
  const now = new Date().getTime();
  const isCompetitionOpen = competitionRunningTimes.find(
    (item) => item.start < now && item.end > now
  );
  return !!isCompetitionOpen;
};

export const getInitialFormStatus = () => {
  return isCompetitionOpen() ? "" : "closed";
};

export const isTemporarilyClosed = () => {
  const now = new Date().getTime();
  return (
    competitionRunningTimes[0].start < now &&
    competitionRunningTimes[2].end > now
  );
};
